jQuery(function() {
    //INFORMACION
    jQuery( '.edit-information' ).on( 'click', function() {
        // Ocultar el boton edit
        
        jQuery('.password-legend').hide();
        jQuery('.information-legend').show();
        jQuery('.edit-information').hide(); 
        
        // Ocultar la muestra de información plana al usuario.
        jQuery('.my-information').hide();

        // Mostrar para editar la información del informacion  
        jQuery('.my-information-fields').show();
        jQuery('.save-button').show();
      
      //OCULTAR TAMBIEN PASSWORD
        jQuery('.edit-password').hide();
        jQuery('.my-password').hide();
        jQuery('.my-password-fields').hide();
    });

    //INFORMACION
    jQuery('.edit-password').on('click', function() {
        // Ocultar el boton edit  
        jQuery('.edit-information').hide();
        jQuery('.password-legend').show();
        jQuery('.information-legend').hide();
        
        // Ocultar la muestra de información plana al usuario.
        jQuery('.my-information').hide();

        // Mostrar para editar la información del informacion  
        jQuery('.my-information-fields').hide();
        
      //OCULTAR TAMBIEN PASSWORD
        jQuery('.edit-password').hide();
        jQuery('.my-password').hide();
        jQuery('.my-password-fields').show();
        jQuery('.save-button').show();
    });

    // GO BACK
    jQuery('.go-back').on('click', function() {
        jQuery('.edit-information').show();
        jQuery('.password-legend').show();
        jQuery('.information-legend').show();
        jQuery('.my-information').show();
        jQuery('.edit-password').show();
        jQuery('.my-password').show();

        jQuery('.my-information-fields').hide();
        jQuery('.save-button').hide();
        jQuery('.my-password-fields').hide();
    });
});
